document.addEventListener('DOMContentLoaded', () => {

  const openButton =
    document.querySelector(
      '.hasta-open-variant-modal'
    );

  const modal =
    document.getElementById(
      'hasta-variant-modal'
    );

  const closeButton =
    document.querySelector(
      '.hasta-variant-modal-close'
    );

  const overlay =
    document.querySelector(
      '.hasta-variant-modal-overlay'
    );

  const variantCards =
    document.querySelectorAll(
      '.hasta-variant-card'
    );

  /*
    OPEN MODAL
  */

  openButton?.addEventListener(
    'click',
    () => {

      modal.classList.add('active');

    }
  );

  /*
    CLOSE MODAL
  */

  function closeModal() {

    modal.classList.remove('active');

  }

  closeButton?.addEventListener(
    'click',
    closeModal
  );

  overlay?.addEventListener(
    'click',
    closeModal
  );

  /*
    VARIANT CHANGE
  */

  variantCards.forEach(card => {

    card.addEventListener(
      'click',
      () => {

        const variantId =
          card.dataset.variantId;

        /*
          Find variant select
        */

        const variantSelect =
          document.querySelector(
            'select[name="id"]'
          );

        /*
          If select exists
        */

        if (variantSelect) {

          variantSelect.value =
            variantId;

          variantSelect.dispatchEvent(
            new Event(
              'change',
              {
                bubbles: true
              }
            )
          );

        }

        /*
          Find radio buttons
        */

        const variantRadio =
          document.querySelector(
            `input[value="${variantId}"]`
          );

        /*
          If radio exists
        */

        if (variantRadio) {

          variantRadio.checked = true;

          variantRadio.dispatchEvent(
            new Event(
              'change',
              {
                bubbles: true
              }
            )
          );

        }

        /*
          Update URL
        */

        const url =
          new URL(window.location);

        url.searchParams.set(
          'variant',
          variantId
        );

        window.history.replaceState(
          {},
          '',
          url
        );

        /*
          Reload page
        */

        window.location.href =
          url.toString();

      }
    );

  });

});